import { getPieveModelReasoningLevels } from '@shared/pieve/modelReasoning.js';

const getModelReasoningLevels = (modelId) => {
  return getPieveModelReasoningLevels(modelId);
};

export default getModelReasoningLevels;
